import * as i0 from '@angular/core';
import { Directive, ContentChildren, EventEmitter, TemplateRef, Optional, SkipSelf, Input, Output, ContentChild, forwardRef, Component, ChangeDetectionStrategy, Inject, ViewChild, Self, NgModule } from '@angular/core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/material/bottom-sheet';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import * as i3$1 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i4$2 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i1$1 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import * as i2$1 from '@angular/material/menu';
import { MatMenuTrigger, MAT_MENU_SCROLL_STRATEGY, MatMenuModule } from '@angular/material/menu';
import * as i4 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i2 from '@firestitch/file';
import { FsFileModule } from '@firestitch/file';
import * as i2$2 from '@angular/cdk/layout';
import { merge, Subject } from 'rxjs';
import { take, takeUntil, debounceTime } from 'rxjs/operators';
import * as i4$1 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i3$2 from '@angular/cdk/bidi';
import * as i1$2 from '@angular/cdk/overlay';
import * as i4$3 from '@angular/cdk/a11y';

function createItemsObserver(data) {
    const itemsObservables = data.reduce((acc, item) => {
        if (item.itemChange$) {
            acc.push(item.itemChange$);
        }
        return acc;
    }, []);
    return merge(...itemsObservables);
}

class FsGroupMenuItemTemplateDirective {
}
/** @nocollapse */ FsGroupMenuItemTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsGroupMenuItemTemplateDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ FsGroupMenuItemTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FsGroupMenuItemTemplateDirective, selector: "[fs-group-menu-item-template]", queries: [{ propertyName: "groupMenuItemTemplateRef", predicate: FsGroupMenuItemTemplateDirective }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsGroupMenuItemTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fs-group-menu-item-template]'
                }]
        }], propDecorators: { groupMenuItemTemplateRef: [{
                type: ContentChildren,
                args: [FsGroupMenuItemTemplateDirective]
            }] } });

class MenuItemDirective {
    constructor(cd, templateRef, parent) {
        this.cd = cd;
        this.templateRef = templateRef;
        this.parent = parent;
        this.ngClass = [];
        this.cssClass = '';
        this.cssId = '';
        this.hidden = false;
        this.dismissAfterClick = true;
        this.target = null;
        this.disabled = false;
        this.queryParams = {};
        this.click$ = new EventEmitter();
        this.itemChange$ = new Subject();
        this._isGroup = false;
    }
    set setTooltip(tooltip) {
        this._tooltip = tooltip;
    }
    set itemsElements(value) {
        this.childrenItems = value.toArray()
            .filter((child) => child !== this);
        this._isGroup = !!this.childrenItems;
        this.checkChildrenVisibility();
        this.itemChange$.next();
    }
    get isGroup() {
        return this._isGroup;
    }
    get visible() {
        if (this.groupHidden !== void 0) {
            return !this.groupHidden;
        }
        else {
            return !this.hidden;
        }
    }
    get tooltip() {
        return this._tooltipValue;
    }
    generateTooltip() {
        if (typeof this._tooltip === 'function') {
            this._tooltipValue = this._tooltip();
        }
        else if (typeof this._tooltip === 'string') {
            this._tooltipValue = this._tooltip;
        }
    }
    get groupItemTemplateRef() {
        return this._groupItemTemplateRef;
    }
    ngOnChanges(changes) {
        if (!this.isGroup && this.parent && changes.hidden && !changes.hidden.firstChange) {
            this.parent.checkChildrenVisibility();
        }
        this.itemChange$.next();
    }
    checkChildrenVisibility() {
        if (this.childrenItems) {
            this.hidden = this.childrenItems.every((item) => item.hidden);
        }
    }
    ngOnDestroy() {
        this.itemChange$.complete();
    }
    click(event) {
        this.click$.next(event);
    }
}
/** @nocollapse */ MenuItemDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MenuItemDirective, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.TemplateRef, optional: true }, { token: MenuItemDirective, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ MenuItemDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: MenuItemDirective, inputs: { ngClass: ["fsClass", "ngClass"], cssClass: ["class", "cssClass"], cssId: ["id", "cssId"], setTooltip: ["tooltip", "setTooltip"], label: "label", hidden: "hidden", show: "show", groupHidden: "groupHidden", dismissAfterClick: "dismissAfterClick", link: "link", target: "target", disabled: "disabled", queryParams: "queryParams" }, outputs: { click$: "click" }, queries: [{ propertyName: "_groupItemTemplateRef", first: true, predicate: FsGroupMenuItemTemplateDirective, descendants: true, read: TemplateRef }, { propertyName: "itemsElements", predicate: MenuItemDirective }], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MenuItemDirective, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.TemplateRef, decorators: [{
                    type: Optional
                }] }, { type: MenuItemDirective, decorators: [{
                    type: SkipSelf
                }, {
                    type: Optional
                }] }]; }, propDecorators: { ngClass: [{
                type: Input,
                args: ['fsClass']
            }], cssClass: [{
                type: Input,
                args: ['class']
            }], cssId: [{
                type: Input,
                args: ['id']
            }], setTooltip: [{
                type: Input,
                args: ['tooltip']
            }], label: [{
                type: Input
            }], hidden: [{
                type: Input
            }], show: [{
                type: Input
            }], groupHidden: [{
                type: Input
            }], dismissAfterClick: [{
                type: Input
            }], link: [{
                type: Input
            }], target: [{
                type: Input
            }], disabled: [{
                type: Input
            }], queryParams: [{
                type: Input
            }], click$: [{
                type: Output,
                args: ['click']
            }], itemsElements: [{
                type: ContentChildren,
                args: [MenuItemDirective]
            }], _groupItemTemplateRef: [{
                type: ContentChild,
                args: [FsGroupMenuItemTemplateDirective, { read: TemplateRef }]
            }] } });

class FsMenuFileItemDirective extends MenuItemDirective {
    constructor() {
        super(...arguments);
        this.multiple = false;
        this.select = new EventEmitter();
        this.error = new EventEmitter();
    }
}
/** @nocollapse */ FsMenuFileItemDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsMenuFileItemDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ FsMenuFileItemDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FsMenuFileItemDirective, selector: "[fs-menu-file-item]", inputs: { multiple: "multiple", accept: "accept", minWidth: "minWidth", minHeight: "minHeight", imageWidth: "imageWidth", imageHeight: "imageHeight" }, outputs: { select: "select", error: "error" }, providers: [
        {
            provide: MenuItemDirective,
            useExisting: forwardRef((() => FsMenuFileItemDirective))
        },
    ], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsMenuFileItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fs-menu-file-item]',
                    providers: [
                        {
                            provide: MenuItemDirective,
                            useExisting: forwardRef((() => FsMenuFileItemDirective))
                        },
                    ]
                }]
        }], propDecorators: { multiple: [{
                type: Input
            }], accept: [{
                type: Input
            }], minWidth: [{
                type: Input
            }], minHeight: [{
                type: Input
            }], imageWidth: [{
                type: Input
            }], imageHeight: [{
                type: Input
            }], select: [{
                type: Output
            }], error: [{
                type: Output
            }] } });

class FsMenuItemDirective extends MenuItemDirective {
}
/** @nocollapse */ FsMenuItemDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsMenuItemDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ FsMenuItemDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FsMenuItemDirective, selector: "fs-menu-group,[fs-menu-item]", providers: [
        {
            provide: MenuItemDirective,
            useExisting: forwardRef((() => FsMenuItemDirective))
        },
    ], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsMenuItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'fs-menu-group,[fs-menu-item]',
                    providers: [
                        {
                            provide: MenuItemDirective,
                            useExisting: forwardRef((() => FsMenuItemDirective))
                        },
                    ]
                }]
        }] });

/**
 * type checking of directive
 * @param dir
 */
const isFileItemDirective = (dir) => {
    return dir instanceof FsMenuFileItemDirective;
};

class BottomItemsListComponent {
    constructor(_bottomSheetRef, _cdRef) {
        this._bottomSheetRef = _bottomSheetRef;
        this._cdRef = _cdRef;
        this._destroy$ = new Subject();
        this.isFileItemDirective = isFileItemDirective;
        //this._cdRef.detach();
    }
    ngOnInit() {
        this._cdRef.detectChanges();
    }
    ngOnChanges(changes) {
        if (changes.items) {
            this.items
                .forEach((item) => item.generateTooltip());
            this._destroy$.next();
            this.subscribeToChanges();
        }
    }
    /**
     * For improve ngFor perf
     * @param index
     */
    trackBy(index) {
        return index;
    }
    /**
     * Click on element
     * @param event
     * @param item
     */
    click(event, item) {
        if (item.select) {
            event.stopPropagation();
            return;
        }
        event.preventDefault();
        const subscription = this._bottomSheetRef.afterDismissed()
            .pipe(take(1))
            .subscribe(() => {
            if (item?.click) {
                item.click(event);
            }
            subscription.unsubscribe();
        });
        if (item?.dismissAfterClick) {
            this._bottomSheetRef.dismiss();
        }
    }
    /**
     * Subscribe to changes in directive parameters.
     * For example we must start detect changes if [hidden] param was changed
     */
    subscribeToChanges() {
        if (this.items && this.items.length) {
            createItemsObserver(this.items)
                .pipe(takeUntil(this._destroy$))
                .subscribe(() => {
                this._cdRef.detectChanges();
            });
        }
    }
}
/** @nocollapse */ BottomItemsListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BottomItemsListComponent, deps: [{ token: i1.MatBottomSheetRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ BottomItemsListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: BottomItemsListComponent, selector: "fs-bottom-items-list", inputs: { items: "items", parentVisible: "parentVisible" }, usesOnChanges: true, ngImport: i0, template: "<ng-container *ngFor=\"let item of items; trackBy: trackBy\">\n  <ng-container *ngIf=\"item.isGroup else menuItem\">\n    <div class=\"mat-menu-item\" [hidden]=\"!item.visible\" disabled>\n      <ng-container *ngIf=\"!!item.label; else tpl\">\n        {{ item.label }}\n      </ng-container>\n      <ng-template \n        #tpl\n        [ngTemplateOutlet]=\"item.groupItemTemplateRef\">\n      </ng-template>\n    </div>\n    <fs-bottom-items-list \n      [items]=\"item.childrenItems\"\n      [hidden]=\"!item.visible\"\n      [parentVisible]=\"item.visible\"\n      class=\"group\">\n    </fs-bottom-items-list>\n  </ng-container>\n  <ng-template #menuItem>\n    <ng-container *ngIf=\"item.visible\">\n      <ng-container *ngIf=\"item.link; else btnLikeAction\">\n        <a \n            (click)=\"click($event, item)\"\n            [routerLink]=\"item.link\"\n            [queryParams]=\"item.queryParams\"\n            [target]=\"item.target\"\n            [class]=\"'mat-menu-item ' + item.cssClass\"\n            [ngClass]=\"item.ngClass\"\n            [attr.disabled]=\"item.disabled ? 'disabled' : null\"\n            [id]=\"item.cssId\">\n          <ng-template [ngTemplateOutlet]=\"item.templateRef\"></ng-template>\n        </a>\n      </ng-container>\n      <ng-template #btnLikeAction>\n         <a \n            (click)=\"click($event, item)\"\n            [class]=\"'mat-menu-item ' + item.cssClass\"\n            [ngClass]=\"item.ngClass\"\n            [attr.disabled]=\"item.disabled ? 'disabled' : null\"\n            [id]=\"item.cssId\">\n          <ng-container *ngIf=\"!isFileItemDirective(item); else file\">\n            <ng-template [ngTemplateOutlet]=\"item.templateRef\"></ng-template>\n          </ng-container>\n\n          <ng-template #file>\n            <ng-container *ngTemplateOutlet=\"\n              fileTmp;\n              context: { $implicit: item }\n            \"></ng-container>\n          </ng-template>\n\n          <ng-template #fileTmp let-item>\n            <fs-file \n                (select)=\"item.select.emit($event)\"\n                [multiple]=\"item.multiple\"\n                [accept]=\"item.accept || ''\"\n                [minWidth]=\"item.minWidth\"\n                [minHeight]=\"item.minHeight\"\n                [imageWidth]=\"item.imageWidth\"\n                [imageHeight]=\"item.imageHeight\"\n                (error)=\"item.error($event)\">\n              <ng-template [ngTemplateOutlet]=\"item.templateRef\"></ng-template>\n            </fs-file>\n          </ng-template>\n        </a>\n      </ng-template>\n    </ng-container>\n  </ng-template>\n</ng-container>\n", styles: ["fs-bottom-items-list a.mat-menu-item{padding:0 32px}.mat-menu-item ::ng-deep .file-label{width:100%;margin:0 -16px;padding:0 16px}\n"], components: [{ type: BottomItemsListComponent, selector: "fs-bottom-items-list", inputs: ["items", "parentVisible"] }, { type: i2.FsFileComponent, selector: "fs-file", inputs: ["minHeight", "minWidth", "orientate", "multiple", "capture", "allowClick", "allowDrop", "accept", "disabled", "imageWidth", "imageHeight", "imageQuality"], outputs: ["select", "error", "beforeProcessing", "clicked", "declined"] }], directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i4.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo", "routerLink"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BottomItemsListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-bottom-items-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngFor=\"let item of items; trackBy: trackBy\">\n  <ng-container *ngIf=\"item.isGroup else menuItem\">\n    <div class=\"mat-menu-item\" [hidden]=\"!item.visible\" disabled>\n      <ng-container *ngIf=\"!!item.label; else tpl\">\n        {{ item.label }}\n      </ng-container>\n      <ng-template \n        #tpl\n        [ngTemplateOutlet]=\"item.groupItemTemplateRef\">\n      </ng-template>\n    </div>\n    <fs-bottom-items-list \n      [items]=\"item.childrenItems\"\n      [hidden]=\"!item.visible\"\n      [parentVisible]=\"item.visible\"\n      class=\"group\">\n    </fs-bottom-items-list>\n  </ng-container>\n  <ng-template #menuItem>\n    <ng-container *ngIf=\"item.visible\">\n      <ng-container *ngIf=\"item.link; else btnLikeAction\">\n        <a \n            (click)=\"click($event, item)\"\n            [routerLink]=\"item.link\"\n            [queryParams]=\"item.queryParams\"\n            [target]=\"item.target\"\n            [class]=\"'mat-menu-item ' + item.cssClass\"\n            [ngClass]=\"item.ngClass\"\n            [attr.disabled]=\"item.disabled ? 'disabled' : null\"\n            [id]=\"item.cssId\">\n          <ng-template [ngTemplateOutlet]=\"item.templateRef\"></ng-template>\n        </a>\n      </ng-container>\n      <ng-template #btnLikeAction>\n         <a \n            (click)=\"click($event, item)\"\n            [class]=\"'mat-menu-item ' + item.cssClass\"\n            [ngClass]=\"item.ngClass\"\n            [attr.disabled]=\"item.disabled ? 'disabled' : null\"\n            [id]=\"item.cssId\">\n          <ng-container *ngIf=\"!isFileItemDirective(item); else file\">\n            <ng-template [ngTemplateOutlet]=\"item.templateRef\"></ng-template>\n          </ng-container>\n\n          <ng-template #file>\n            <ng-container *ngTemplateOutlet=\"\n              fileTmp;\n              context: { $implicit: item }\n            \"></ng-container>\n          </ng-template>\n\n          <ng-template #fileTmp let-item>\n            <fs-file \n                (select)=\"item.select.emit($event)\"\n                [multiple]=\"item.multiple\"\n                [accept]=\"item.accept || ''\"\n                [minWidth]=\"item.minWidth\"\n                [minHeight]=\"item.minHeight\"\n                [imageWidth]=\"item.imageWidth\"\n                [imageHeight]=\"item.imageHeight\"\n                (error)=\"item.error($event)\">\n              <ng-template [ngTemplateOutlet]=\"item.templateRef\"></ng-template>\n            </fs-file>\n          </ng-template>\n        </a>\n      </ng-template>\n    </ng-container>\n  </ng-template>\n</ng-container>\n", styles: ["fs-bottom-items-list a.mat-menu-item{padding:0 32px}.mat-menu-item ::ng-deep .file-label{width:100%;margin:0 -16px;padding:0 16px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.MatBottomSheetRef }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { items: [{
                type: Input
            }], parentVisible: [{
                type: Input
            }] } });

class FsBottomSheetComponent {
    constructor(data, _cd) {
        this.data = data;
        this._cd = _cd;
    }
    ngOnInit() {
        this._cd.detectChanges();
    }
}
/** @nocollapse */ FsBottomSheetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsBottomSheetComponent, deps: [{ token: MAT_BOTTOM_SHEET_DATA }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ FsBottomSheetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsBottomSheetComponent, selector: "fs-bottom-sheet", ngImport: i0, template: "<mat-nav-list class=\"{{ data.klass }}\">\n  <div class=\"fs-menu-container\">\n    <fs-bottom-items-list [items]=\"data.items\"></fs-bottom-items-list>\n  </div>\n</mat-nav-list>\n", styles: [".mat-list-base{padding-top:0;margin:0 -16px}\n"], components: [{ type: i1$1.MatNavList, selector: "mat-nav-list", inputs: ["disableRipple", "disabled"], exportAs: ["matNavList"] }, { type: BottomItemsListComponent, selector: "fs-bottom-items-list", inputs: ["items", "parentVisible"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsBottomSheetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-bottom-sheet', changeDetection: ChangeDetectionStrategy.OnPush, template: "<mat-nav-list class=\"{{ data.klass }}\">\n  <div class=\"fs-menu-container\">\n    <fs-bottom-items-list [items]=\"data.items\"></fs-bottom-items-list>\n  </div>\n</mat-nav-list>\n", styles: [".mat-list-base{padding-top:0;margin:0 -16px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_BOTTOM_SHEET_DATA]
                }] }, { type: i0.ChangeDetectorRef }]; } });

class MenuItemsListComponent {
    constructor(_cdRef) {
        this._cdRef = _cdRef;
        this.clicked = new EventEmitter();
        this._destroy$ = new Subject();
        this.isFileItemDirective = isFileItemDirective;
    }
    ngOnChanges(changes) {
        if (changes.items) {
            this.items
                .forEach((item) => item.generateTooltip());
            this._cdRef.detectChanges();
            this._destroy$.next();
            this.subscribeToChanges();
        }
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    /**
     * For improve ngFor perf
     * @param index
     */
    trackBy(index) {
        return index;
    }
    fileSelected(item, event) {
        item.select.emit(event);
        this.clicked.emit();
    }
    /**
     * Subscribe to changes in directive parameters.
     * For example we must start detect changes if [hidden] param was changed
     */
    subscribeToChanges() {
        if (this.items && this.items.length) {
            createItemsObserver(this.items)
                .pipe(takeUntil(this._destroy$))
                .subscribe(() => {
                this._cdRef.detectChanges();
            });
        }
    }
}
/** @nocollapse */ MenuItemsListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MenuItemsListComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ MenuItemsListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: MenuItemsListComponent, selector: "fs-menu-items-list", inputs: { items: "items", parentVisible: "parentVisible" }, outputs: { clicked: "clicked" }, usesOnChanges: true, ngImport: i0, template: "<ng-container *ngFor=\"let item of items; trackBy: trackBy\">\n  <ng-container *ngIf=\"item.isGroup; else menuItem\">\n    <div class=\"fs-menu-groupped-list\" [hidden]=\"!item.visible\">\n      <div class=\"mat-menu-item fs-menu-group-label\" disabled>\n        <ng-container *ngIf=\"!!item.label; else tpl\">\n          {{ item.label }}\n        </ng-container>\n        <ng-template\n          #tpl\n          [ngTemplateOutlet]=\"item.groupItemTemplateRef\">\n        </ng-template>\n      </div>\n      <fs-menu-items-list\n        [items]=\"item.childrenItems\"\n        [parentVisible]=\"item.visible\">\n      </fs-menu-items-list>\n    </div>\n  </ng-container>\n  <ng-template #menuItem>\n    <ng-container *ngIf=\"item.link; else btn\">\n      <div\n          [matTooltip]=\"item.tooltip\"\n          [matTooltipDisabled]=\"!item.tooltip\">\n        <a\n          mat-menu-item\n          *ngIf=\"item.visible\"\n          [routerLink]=\"item.link\"\n          [queryParams]=\"item.queryParams\"\n          [target]=\"item.target\"\n          (click)=\"item.click($event)\"\n          [class]=\"item.cssClass\"\n          [disabled]=\"item.disabled\"\n          [ngClass]=\"item.ngClass\"\n          [id]=\"item.cssId\">\n          <ng-template [ngTemplateOutlet]=\"item.templateRef\"></ng-template>\n        </a>\n      </div>\n    </ng-container>\n    <ng-template #btn>\n      <div\n          [matTooltip]=\"item.tooltip\"\n          [matTooltipDisabled]=\"!item.tooltip\">\n        <button\n            type=\"button\"\n            mat-menu-item\n            *ngIf=\"item.visible\"\n            (click)=\"item.click($event)\"\n            [class]=\"item.cssClass\"\n            [ngClass]=\"item.ngClass\"\n            [disabled]=\"item.disabled\"\n            [id]=\"item.cssId\">\n          <ng-container *ngIf=\"!isFileItemDirective(item) else file\">\n            <ng-template [ngTemplateOutlet]=\"item.templateRef\"></ng-template>\n          </ng-container>\n\n          <ng-template #file>\n            <ng-container *ngTemplateOutlet=\"\n              fileTmp;\n              context: { $implicit: item }\n            \"></ng-container>\n          </ng-template>\n\n          <ng-template #fileTmp let-item>\n            <fs-file\n              (click)=\"$event.stopPropagation()\"\n              (select)=\"fileSelected(item, $event)\"\n              (cancel)=\"clicked.emit()\"\n              [multiple]=\"item.multiple\">\n              <ng-template [ngTemplateOutlet]=\"item.templateRef\"></ng-template>\n            </fs-file>\n          </ng-template>\n        </button>\n      </div>\n    </ng-template>\n  </ng-template>\n</ng-container>\n", styles: [":host ::ng-deep .fs-menu-groupped-list a,:host ::ng-deep .fs-menu-groupped-list button{padding-left:32px}:host ::ng-deep .mat-menu-item .file-label{width:100%;margin:0 -16px;padding:0 16px}\n"], components: [{ type: MenuItemsListComponent, selector: "fs-menu-items-list", inputs: ["items", "parentVisible"], outputs: ["clicked"] }, { type: i2$1.MatMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple", "role"], exportAs: ["matMenuItem"] }, { type: i2.FsFileComponent, selector: "fs-file", inputs: ["minHeight", "minWidth", "orientate", "multiple", "capture", "allowClick", "allowDrop", "accept", "disabled", "imageWidth", "imageHeight", "imageQuality"], outputs: ["select", "error", "beforeProcessing", "clicked", "declined"] }], directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i4$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { type: i4.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo", "routerLink"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MenuItemsListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-menu-items-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngFor=\"let item of items; trackBy: trackBy\">\n  <ng-container *ngIf=\"item.isGroup; else menuItem\">\n    <div class=\"fs-menu-groupped-list\" [hidden]=\"!item.visible\">\n      <div class=\"mat-menu-item fs-menu-group-label\" disabled>\n        <ng-container *ngIf=\"!!item.label; else tpl\">\n          {{ item.label }}\n        </ng-container>\n        <ng-template\n          #tpl\n          [ngTemplateOutlet]=\"item.groupItemTemplateRef\">\n        </ng-template>\n      </div>\n      <fs-menu-items-list\n        [items]=\"item.childrenItems\"\n        [parentVisible]=\"item.visible\">\n      </fs-menu-items-list>\n    </div>\n  </ng-container>\n  <ng-template #menuItem>\n    <ng-container *ngIf=\"item.link; else btn\">\n      <div\n          [matTooltip]=\"item.tooltip\"\n          [matTooltipDisabled]=\"!item.tooltip\">\n        <a\n          mat-menu-item\n          *ngIf=\"item.visible\"\n          [routerLink]=\"item.link\"\n          [queryParams]=\"item.queryParams\"\n          [target]=\"item.target\"\n          (click)=\"item.click($event)\"\n          [class]=\"item.cssClass\"\n          [disabled]=\"item.disabled\"\n          [ngClass]=\"item.ngClass\"\n          [id]=\"item.cssId\">\n          <ng-template [ngTemplateOutlet]=\"item.templateRef\"></ng-template>\n        </a>\n      </div>\n    </ng-container>\n    <ng-template #btn>\n      <div\n          [matTooltip]=\"item.tooltip\"\n          [matTooltipDisabled]=\"!item.tooltip\">\n        <button\n            type=\"button\"\n            mat-menu-item\n            *ngIf=\"item.visible\"\n            (click)=\"item.click($event)\"\n            [class]=\"item.cssClass\"\n            [ngClass]=\"item.ngClass\"\n            [disabled]=\"item.disabled\"\n            [id]=\"item.cssId\">\n          <ng-container *ngIf=\"!isFileItemDirective(item) else file\">\n            <ng-template [ngTemplateOutlet]=\"item.templateRef\"></ng-template>\n          </ng-container>\n\n          <ng-template #file>\n            <ng-container *ngTemplateOutlet=\"\n              fileTmp;\n              context: { $implicit: item }\n            \"></ng-container>\n          </ng-template>\n\n          <ng-template #fileTmp let-item>\n            <fs-file\n              (click)=\"$event.stopPropagation()\"\n              (select)=\"fileSelected(item, $event)\"\n              (cancel)=\"clicked.emit()\"\n              [multiple]=\"item.multiple\">\n              <ng-template [ngTemplateOutlet]=\"item.templateRef\"></ng-template>\n            </fs-file>\n          </ng-template>\n        </button>\n      </div>\n    </ng-template>\n  </ng-template>\n</ng-container>\n", styles: [":host ::ng-deep .fs-menu-groupped-list a,:host ::ng-deep .fs-menu-groupped-list button{padding-left:32px}:host ::ng-deep .mat-menu-item .file-label{width:100%;margin:0 -16px;padding:0 16px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { items: [{
                type: Input
            }], parentVisible: [{
                type: Input
            }], clicked: [{
                type: Output
            }] } });

class FsMenuComponent {
    constructor(_bottomSheet, _breakpointObserver, _cdRef) {
        this._bottomSheet = _bottomSheet;
        this._breakpointObserver = _breakpointObserver;
        this._cdRef = _cdRef;
        this.klass = null;
        this.buttonClass = '';
        this.buttonType = 'icon';
        this.buttonColor = 'primary';
        this.opened = new EventEmitter();
        this.closed = new EventEmitter();
        // Items with TemplateRefs and DirectiveRef for passing to bottomSheet
        this.items = [];
        this.useInternalTrigger = false;
        this.mobile = false;
        this.menuOpened = false;
        this.initialized = false;
        this._resolutionChanged = false;
        // Active bottom sheet that was opened
        this._activeSheetRef = null;
        this._destroy$ = new Subject();
        //this._cdRef.detach();
    }
    set itemsElements(value) {
        this.items = value.toArray();
    }
    // Catch trigger for matMenu
    set internalMatMenuTrigger(val) {
        if (val) {
            this.useInternalTrigger = true;
        }
        this._internalMatMenuTrigger = val;
    }
    ;
    set externalMatMenuTrigger(val) {
        this.useInternalTrigger = false;
        this._externalMatMenuTrigger = val;
        this._cdRef.detectChanges();
    }
    set resolutionChanged(val) {
        this._resolutionChanged = val;
    }
    get resolutionChanged() {
        return this._resolutionChanged;
    }
    get matMenuTrigger() {
        if (this.useInternalTrigger) {
            return this._internalMatMenuTrigger;
        }
        else {
            return this._externalMatMenuTrigger;
        }
    }
    ngOnInit() {
        this.subscribeToResChanges();
        this.initialized = true;
        this._cdRef.detectChanges();
    }
    ngAfterViewInit() {
        if (!this._externalMatMenuTrigger) {
            this.useInternalTrigger = true;
            this._cdRef.detectChanges();
        }
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    /**
     * Subscribe to window resolution changes
     * and switch between mobile and desktop
     */
    subscribeToResChanges() {
        const layoutChanges = this._breakpointObserver.observe([
            FsMenuComponent.MOBILE_BREAKPOINT,
        ]);
        layoutChanges
            .pipe(debounceTime(500), takeUntil(this._destroy$))
            .subscribe(result => {
            // Set mobile/desktop flag
            this.mobile = result.breakpoints[FsMenuComponent.MOBILE_BREAKPOINT];
            if (this.menuOpened) {
                // Flag that menus was closed not by user
                this.resolutionChanged = true;
                if (this.mobile) {
                    this.closeMatMenu();
                    this.openSheetMenu();
                }
                else {
                    this.closeSheetMenu();
                    // Must be here because we should wait till menuTrigger will be catched by @ViewChild
                    setTimeout(() => {
                        if (this.matMenuTrigger) {
                            this.matMenuTrigger.openMenu();
                            // Detect changes because for strategies like OnPush if won't detected by default
                            this._cdRef.detectChanges();
                        }
                    });
                }
                // Detect changes because for strategies like OnPush if won't detected by default
                this._cdRef.detectChanges();
            }
            else {
                // Detect changes because for strategies like OnPush if won't detected by default
                this._cdRef.detectChanges();
            }
        });
    }
    /**
     * Open fs menu depends from mode
     */
    openMenu() {
        this._updateHidden(this.items);
        this._cdRef.detectChanges();
        if (this.mobile) {
            this.openSheetMenu();
        }
        else {
            this.openMatMenu();
        }
        this.opened.emit();
        this._cdRef.detectChanges();
    }
    /**
     * Close fs menu depends from mode
     */
    closeMenu() {
        if (this.mobile) {
            this.closeSheetMenu();
        }
        else {
            this.closeMatMenu();
        }
    }
    /**
     * Open Mat Menu
     */
    openMatMenu() {
        this.menuOpened = true;
        this.resolutionChanged = false;
        this.matMenuTrigger.openMenu();
    }
    /**
     * Close Mat Menu
     */
    closeMatMenu() {
        if (this.matMenuTrigger) {
            this.matMenuTrigger.closeMenu();
        }
    }
    /**
     * After menu close event
     */
    closedMatMenu() {
        // Give time for the fade out effect to finish before hiding items
        setTimeout(() => {
            if (!this.resolutionChanged) {
                this.menuOpened = false;
            }
            this.resolutionChanged = false;
            this._cdRef.detectChanges();
        }, 100);
        this.closed.emit();
    }
    /**
     * Open Mat Bottom Sheet
     */
    openSheetMenu() {
        this._activeSheetRef = this._bottomSheet.open(FsBottomSheetComponent, {
            data: { items: this.items, klass: this.klass }
        });
        this.menuOpened = true;
        this._activeSheetRef.afterDismissed()
            .pipe(takeUntil(this._destroy$))
            .subscribe(() => {
            if (!this.resolutionChanged) {
                this.menuOpened = false;
            }
            this.resolutionChanged = false;
        });
    }
    /**
     * Close Mat Bottom Sheet
     */
    closeSheetMenu() {
        if (this._activeSheetRef) {
            this._activeSheetRef.dismiss();
        }
    }
    _updateHidden(items) {
        items
            .forEach((item) => {
            this._updateHidden(item.childrenItems || []);
            if (item.show) {
                item.hidden = item.show();
            }
        });
    }
}
FsMenuComponent.MOBILE_BREAKPOINT = '(max-width: 599px)';
/** @nocollapse */ FsMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsMenuComponent, deps: [{ token: i1.MatBottomSheet }, { token: i2$2.BreakpointObserver }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ FsMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsMenuComponent, selector: "fs-menu", inputs: { klass: ["class", "klass"], buttonClass: "buttonClass", buttonType: "buttonType", buttonColor: "buttonColor" }, outputs: { opened: "opened", closed: "closed" }, queries: [{ propertyName: "itemsElements", predicate: MenuItemDirective }], viewQueries: [{ propertyName: "internalMatMenuTrigger", first: true, predicate: MatMenuTrigger, descendants: true }, { propertyName: "fsMenuRef", first: true, predicate: ["fsMenu"], descendants: true, static: true }], ngImport: i0, template: "<ng-template [ngIf]=\"!mobile\" [ngIfElse]=\"sheetMenu\">\n  <ng-container *ngIf=\"buttonType === 'icon'\">\n    <button\n        type=\"button\"\n        [ngClass]=\"buttonClass\"\n        mat-icon-button\n        *ngIf=\"useInternalTrigger\"\n        [matMenuTriggerFor]=\"fsMenu\"\n        #menuTrigger=\"matMenuTrigger\"\n        (click)=\"openMenu()\">\n      <mat-icon>more_vert</mat-icon>\n    </button>\n  </ng-container>\n  <ng-container *ngIf=\"buttonType === 'miniFab'\">\n    <button\n        type=\"button\"\n        [ngClass]=\"buttonClass\"\n        mat-mini-fab\n        [color]=\"buttonColor\"\n        *ngIf=\"useInternalTrigger\"\n        [matMenuTriggerFor]=\"fsMenu\"\n        #menuTrigger=\"matMenuTrigger\"\n        (click)=\"openMenu()\">\n      <mat-icon>more_vert</mat-icon>\n    </button>\n  </ng-container>\n</ng-template>\n\n<ng-template #sheetMenu>\n  <ng-container *ngIf=\"buttonType === 'icon'\">\n    <button\n        type=\"button\"\n        mat-icon-button\n        [ngClass]=\"buttonClass\"\n        *ngIf=\"useInternalTrigger\"\n        (click)=\"openMenu()\">\n      <mat-icon>more_vert</mat-icon>\n    </button>\n  </ng-container>\n  <ng-container *ngIf=\"buttonType === 'miniFab'\">\n    <button\n        type=\"button\"\n        mat-mini-fab\n        [color]=\"buttonColor\"\n        [ngClass]=\"buttonClass\"\n        *ngIf=\"useInternalTrigger\"\n        (click)=\"openMenu()\">\n      <mat-icon>more_vert</mat-icon>\n    </button>\n  </ng-container>\n</ng-template>\n\n<mat-menu\n    #fsMenu=\"matMenu\"\n    [class]=\"klass\"\n    (close)=\"closedMatMenu()\">\n  <div class=\"fs-menu-container\">\n    <ng-container *ngIf=\"menuOpened\">\n      <fs-menu-items-list      \n        [items]=\"items\"\n        (clicked)=\"closeMenu()\">\n      </fs-menu-items-list>\n    </ng-container>\n  </div>\n</mat-menu>\n", styles: ["::ng-deep *[hidden]{display:none!important}\n"], components: [{ type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i4$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i2$1.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { type: MenuItemsListComponent, selector: "fs-menu-items-list", inputs: ["items", "parentVisible"], outputs: ["clicked"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2$1.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-menu', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-template [ngIf]=\"!mobile\" [ngIfElse]=\"sheetMenu\">\n  <ng-container *ngIf=\"buttonType === 'icon'\">\n    <button\n        type=\"button\"\n        [ngClass]=\"buttonClass\"\n        mat-icon-button\n        *ngIf=\"useInternalTrigger\"\n        [matMenuTriggerFor]=\"fsMenu\"\n        #menuTrigger=\"matMenuTrigger\"\n        (click)=\"openMenu()\">\n      <mat-icon>more_vert</mat-icon>\n    </button>\n  </ng-container>\n  <ng-container *ngIf=\"buttonType === 'miniFab'\">\n    <button\n        type=\"button\"\n        [ngClass]=\"buttonClass\"\n        mat-mini-fab\n        [color]=\"buttonColor\"\n        *ngIf=\"useInternalTrigger\"\n        [matMenuTriggerFor]=\"fsMenu\"\n        #menuTrigger=\"matMenuTrigger\"\n        (click)=\"openMenu()\">\n      <mat-icon>more_vert</mat-icon>\n    </button>\n  </ng-container>\n</ng-template>\n\n<ng-template #sheetMenu>\n  <ng-container *ngIf=\"buttonType === 'icon'\">\n    <button\n        type=\"button\"\n        mat-icon-button\n        [ngClass]=\"buttonClass\"\n        *ngIf=\"useInternalTrigger\"\n        (click)=\"openMenu()\">\n      <mat-icon>more_vert</mat-icon>\n    </button>\n  </ng-container>\n  <ng-container *ngIf=\"buttonType === 'miniFab'\">\n    <button\n        type=\"button\"\n        mat-mini-fab\n        [color]=\"buttonColor\"\n        [ngClass]=\"buttonClass\"\n        *ngIf=\"useInternalTrigger\"\n        (click)=\"openMenu()\">\n      <mat-icon>more_vert</mat-icon>\n    </button>\n  </ng-container>\n</ng-template>\n\n<mat-menu\n    #fsMenu=\"matMenu\"\n    [class]=\"klass\"\n    (close)=\"closedMatMenu()\">\n  <div class=\"fs-menu-container\">\n    <ng-container *ngIf=\"menuOpened\">\n      <fs-menu-items-list      \n        [items]=\"items\"\n        (clicked)=\"closeMenu()\">\n      </fs-menu-items-list>\n    </ng-container>\n  </div>\n</mat-menu>\n", styles: ["::ng-deep *[hidden]{display:none!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.MatBottomSheet }, { type: i2$2.BreakpointObserver }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { klass: [{
                type: Input,
                args: ['class']
            }], buttonClass: [{
                type: Input
            }], buttonType: [{
                type: Input
            }], buttonColor: [{
                type: Input
            }], opened: [{
                type: Output
            }], closed: [{
                type: Output
            }], itemsElements: [{
                type: ContentChildren,
                args: [MenuItemDirective]
            }], internalMatMenuTrigger: [{
                type: ViewChild,
                args: [MatMenuTrigger]
            }], fsMenuRef: [{
                type: ViewChild,
                args: ['fsMenu', { static: true }]
            }] } });

class FsMenuTriggerDirective extends MatMenuTrigger {
    constructor(_overlay, _element, _viewContainerRef, scrollStrategy, _parentMenu, _menuItemInstance, _dir, _focusMonitor) {
        super(_overlay, _element, _viewContainerRef, scrollStrategy, _parentMenu, _menuItemInstance, _dir, _focusMonitor);
        this.fsMenu = null;
    }
    ngOnInit() {
        this.menu = this.fsMenu.fsMenuRef;
        this.fsMenu.externalMatMenuTrigger = this;
    }
    _handleKeydown(event) {
        this._triggerClick();
    }
    /** Handles click events on the trigger. */
    _handleClick(event) {
        this._triggerClick();
    }
    _triggerClick() {
        if (this.fsMenu.menuOpened) {
            this.fsMenu.closeMenu();
        }
        else {
            this.fsMenu.openMenu();
        }
    }
}
/** @nocollapse */ FsMenuTriggerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsMenuTriggerDirective, deps: [{ token: i1$2.Overlay }, { token: i0.ElementRef }, { token: i0.ViewContainerRef }, { token: MAT_MENU_SCROLL_STRATEGY }, { token: i2$1.MatMenu, optional: true }, { token: i2$1.MatMenuItem, optional: true, self: true }, { token: i3$2.Directionality, optional: true }, { token: i4$3.FocusMonitor }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ FsMenuTriggerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FsMenuTriggerDirective, selector: "[fsMenuTriggerFor]", inputs: { fsMenu: ["fsMenuTriggerFor", "fsMenu"] }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsMenuTriggerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsMenuTriggerFor]',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.Overlay }, { type: i0.ElementRef }, { type: i0.ViewContainerRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_MENU_SCROLL_STRATEGY]
                }] }, { type: i2$1.MatMenu, decorators: [{
                    type: Optional
                }] }, { type: i2$1.MatMenuItem, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i3$2.Directionality, decorators: [{
                    type: Optional
                }] }, { type: i4$3.FocusMonitor }]; }, propDecorators: { fsMenu: [{
                type: Input,
                args: ['fsMenuTriggerFor']
            }] } });

class FsMenuModule {
    static forRoot() {
        return {
            ngModule: FsMenuModule
        };
    }
}
/** @nocollapse */ FsMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ FsMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsMenuModule, declarations: [FsMenuComponent,
        FsBottomSheetComponent,
        MenuItemsListComponent,
        BottomItemsListComponent,
        FsMenuItemDirective,
        FsMenuFileItemDirective,
        FsMenuTriggerDirective,
        FsGroupMenuItemTemplateDirective], imports: [CommonModule,
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatBottomSheetModule,
        MatListModule,
        MatTooltipModule,
        FsFileModule], exports: [FsMenuComponent,
        FsMenuItemDirective,
        FsMenuTriggerDirective,
        FsMenuFileItemDirective,
        FsGroupMenuItemTemplateDirective] });
/** @nocollapse */ FsMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsMenuModule, imports: [[
            CommonModule,
            RouterModule,
            MatButtonModule,
            MatIconModule,
            MatMenuModule,
            MatBottomSheetModule,
            MatListModule,
            MatTooltipModule,
            FsFileModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule,
                        MatButtonModule,
                        MatIconModule,
                        MatMenuModule,
                        MatBottomSheetModule,
                        MatListModule,
                        MatTooltipModule,
                        FsFileModule,
                    ],
                    exports: [
                        FsMenuComponent,
                        FsMenuItemDirective,
                        FsMenuTriggerDirective,
                        FsMenuFileItemDirective,
                        FsGroupMenuItemTemplateDirective,
                    ],
                    declarations: [
                        FsMenuComponent,
                        FsBottomSheetComponent,
                        MenuItemsListComponent,
                        BottomItemsListComponent,
                        FsMenuItemDirective,
                        FsMenuFileItemDirective,
                        FsMenuTriggerDirective,
                        FsGroupMenuItemTemplateDirective,
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FsGroupMenuItemTemplateDirective, FsMenuComponent, FsMenuFileItemDirective, FsMenuItemDirective, FsMenuModule, FsMenuTriggerDirective };
